// HomePage.js
import React from 'react';
import DashboardPage from '../dashboard/DashboardPage';

const HomePage = () => {
  return <DashboardPage />;
};

export default HomePage;
